import { ChevronRight, Folder, ListOrdered } from 'lucide-react';
import { Link } from 'react-router';
import type { CollectionDTO } from '../../../shared/dto/library';
import { useT } from '../../i18n';
import { PackBadge } from './OfflineBadge';

export const COLLECTION_ICON = { setlist: ListOrdered, folder: Folder } as const;

/** Setlist / folder row: icon, name, description, song count. */
export function CollectionRow({ collection, to, count }: { collection: CollectionDTO; to: string; count: number }) {
  const t = useT();
  const Icon = COLLECTION_ICON[collection.kind];
  return (
    <li>
      <Link
        to={to}
        className="flex min-h-16 items-center gap-4 px-4 py-3 transition hover:bg-[var(--surface-2)] active:bg-[var(--accent-soft)] md:px-5"
      >
        <span className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-[var(--accent-soft)] text-[var(--accent)]">
          <Icon className="size-6" aria-hidden />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-[18px] leading-snug font-semibold break-words">{collection.name}</div>
          {collection.description ? <div className="truncate text-[15px] text-[var(--muted)]">{collection.description}</div> : null}
        </div>
        <PackBadge kind="collection" refId={collection.id} />
        <span className="shrink-0 text-[15px] text-[var(--muted)] tabular-nums">{t('library.song_count', { count })}</span>
        <ChevronRight className="size-5 shrink-0 text-[var(--muted)]" aria-hidden />
      </Link>
    </li>
  );
}
